import { dashboardApiMiddleware } from "../api.middlewares";

export const sharePost = dashboardApiMiddleware<any, any>()({
  method: "post",
  endpoint: "/api/socialnetwork/share",
});
